import axios from 'axios'

export default {
  changePassword: (payload) => {
    return axios.post("/api/admin/users/changepassword", payload);
  },
  changeEmail: (payload) => {
    return axios.post("/api/admin/users/changeEmail", payload);
  },
};
